/* Fixed value sets, as TypeScript unions.
 *
 * These are the single source of truth: the backend mirrors them as VarChar
 * columns and validates against them, the frontend builds pickers from them.
 * There are no Prisma `enum` blocks and no reference tables — one definition,
 * so a dropdown and a validator cannot drift apart. */
/** Who someone is in the shop (IDEA.md §5).
 *
 * Viewing: internal staff (owner, admin, staff) see every job; subcontractors
 * see only jobs they are assigned to.
 * Editing: requires assignment — except owner and admin, who run the office
 * and must be able to fix jobs they aren't on.
 * Money is NOT a role. It is `financialAccess` on the membership. */
export const ROLES = ['owner', 'admin', 'staff', 'subcontractor'];
/** How the shop says each role out loud. Never render a raw role id. */
export const ROLE_LABEL = {
    owner: 'Owner',
    admin: 'Admin (office)',
    staff: 'Staff',
    subcontractor: 'Subcontractor',
};
/** Owner and admin run the office: they can create and fix any job, assigned
 *  or not. Everyone else needs the assignment. */
export const OFFICE_ROLES = ['owner', 'admin'];
/** Internal staff see every job in the shop; subcontractors do not, and never
 *  see customer detail. */
export const INTERNAL_ROLES = ['owner', 'admin', 'staff'];
/** A membership is what ties a person to the shop. Deactivating keeps the
 *  history — people come back, and their stage events must still resolve. */
export const MEMBERSHIP_STATUSES = ['active', 'deactivated'];
/** Trade (cabinetmaker, joiner, builder) or retail (a homeowner direct). Trade
 *  is nearly all of the shop's work, so it is what a new customer starts as. */
export const CUSTOMER_TYPES = ['Trade', 'Retail'];
/** How the jobs list can be ordered. `board` is the shop's own order — the
 *  sequence the cards sit in on the board — and it is what the board itself
 *  asks for; the other three are columns the office clicks on the jobs list. */
export const JOB_SORTS = ['board', 'code', 'promised', 'deadline'];
/** How the customers list can be ordered.
 *
 * `name` is how the office scans the list — it is the column they read down.
 * `promised` is the other question a customer list gets asked: who is the shop
 * owing work to next. Type, contact and the counts are not orderable on
 * purpose; a column nobody sorts by is a heading nobody has to decode. */
export const CUSTOMER_SORTS = ['name', 'promised'];
/** Which way a sorted column runs. Clicking its header toggles between them. */
export const SORT_DIRECTIONS = ['asc', 'desc'];
/** How loudly a shop notice reads.
 *
 *  `notice` is the ordinary thing pinned on the board — the run is off on
 *  Friday, the new topcoat is in. `urgent` is the one the shop has to act on,
 *  and it is drawn in the urgent colour with the word beside it, never the
 *  colour alone (IDEA.md §10). Two levels rather than four: a board where
 *  everything is a different colour is a board nobody reads. */
export const NOTICE_LEVELS = ['notice', 'urgent'];
/** How the shop says each level out loud. Never render a raw level. */
export const NOTICE_LEVEL_LABEL = {
    notice: 'Notice',
    urgent: 'Urgent',
};
//# sourceMappingURL=enums.js.map